import { AbstractBlock } from '../AbstractBlock';
import { ShapeSettings } from '../setting/ShapeSettings';
import { ColorSettings } from '../setting/ColorSettings';
import { CodeSetting } from '../setting/CodeSetting';
import { GlobalImport } from '../../utils/GlobalImport';
import { BlockType } from '../../@types/BlockType';
import { block_translation } from '../../lang/BlockTranslation';
const Blockly = GlobalImport.getBlockly();
const t = block_translation;
export class SoundElement extends AbstractBlock {
  constructor() {
    super('sound_elem_v2', t.to('サウンド', 'sound'));
  }

  defineBlock(block: BlockType): void {
    ShapeSettings.setElementShape(block);
    ColorSettings.setObjectColor(block);

    ShapeSettings.setTitleField(block, this.title);
    const fieldText = new Blockly.FieldTextInput('');
    block.appendDummyInput().appendField('ファイル:').appendField(fieldText, 'src');

    block.appendDummyInput().appendField('位置:');
    ShapeSettings.setVR3Fields(block, 'position', 0, 1, 0);
    ShapeSettings.addAttributeInput(block);
  }

  codeGenerateCore(block: BlockType): string {
    let attribute = CodeSetting.getSubAttributeCode(block);
    const src = CodeSetting.getFieldValue(block, 'src');
    attribute += CodeSetting.getVR3FieldValues(block, 'position');
    // attribute +=  " src = '"  + src + "' autoplay='true' loop volume ";
    attribute += CodeSetting.getAttributeCode('src', src);
    attribute += CodeSetting.getAttributeCode('autoplay', 'true');
    attribute += CodeSetting.getAttributeCode('loop', '');
    attribute += CodeSetting.getAttributeCode('volume', '');
    attribute += CodeSetting.getAttributeCode('class', 'clickable collidable');
    const str = CodeSetting.getElementCode(this.name_for_code, attribute, block.id, '');
    return str;
  }
}
